
import { call, put, takeLatest } from 'redux-saga/effects';
import {ASYNC_SIGNIN,SIGNIN_SUCCESS,initialState, ASYNC_LOGOUT, LOGOUT_SUCCESS, ASYNC_UPDATE_PASSWORD} from '../redux/ducks/userDuck'
import Axios from 'axios';
import sha256 from 'crypto-js/sha256';
import sha1 from 'crypto-js/sha1';
import { LoginUser, LogoutUser, UpdateUserPassword } from '../server/WebServiceUrl';
import Cookies from 'js-cookie';
import { READ_MERCHANT_SUCCESS } from '../redux/ducks/merchant';

async function axiosSignIn(signInData){
  let result = {};
  try{
    result = await Axios.post(LoginUser,signInData);     
  }catch(e){

  }
  return result;
}

async function axiosSignOut(){
  let result = {};
  try{
    result = await Axios.post(LogoutUser);     
  }catch(e){

  }
  return result;
}

async function axiosUpdatePassword(data){
  let result = {};
  try{
    result = await Axios.post(UpdateUserPassword, data);     
  }catch(e){
    if (e.response && e.response.data && e.response.data.error) {
      return e.response.data;
    }
  }
  return result;
}


function* asyncSignIn(signInPayload) {  

    const callback = signInPayload.payload.callback || (()=>({}));
    let signInData = { email: signInPayload.payload.email, password: signInPayload.payload.password };
    let rawPw = signInData.password
    signInData.password = sha256(rawPw).toString();
    signInData.passwordHash = sha1(rawPw).toString();
    
    let signInResult = yield call(  
      axiosSignIn,signInData
    );
    
    
    let userPayload = initialState

    let merchantPayload = {};
    if(signInResult && signInResult.status && signInResult.data){          
      Cookies.set('authorization', signInResult.data.authorization)     
      Cookies.set('systemTime', signInResult.data.systemTime) 
      userPayload.email =  signInResult.data.user.email
      userPayload.type = signInResult.data.user.type
      userPayload.authorization = signInResult.data.authorization

      if(signInResult.data.merchant){
        merchantPayload = signInResult.data.merchant;
      }
      if(window.MA) {
        window.MA.events("general", "login", "email", signInResult.data.user.email, {loginTime: new Date()});
      }
    }else{
      signInResult = {
        pass: false
      }
      userPayload.authorization = 'invalid'
    }   
    // update state first prevent redirect 
    yield put({ type: SIGNIN_SUCCESS, payload: userPayload  });

    if(callback){
       callback(signInResult)
    }
    
    // yield put({ type: SIGNIN_SUCCESS, payload: userPayload  });
    yield put({type: READ_MERCHANT_SUCCESS, payload: merchantPayload});
  }

  function* asyncSignOut(args){
    const callback = args.payload.callback || (()=>({}));
    let signOutResult = yield call(axiosSignOut);
    if(callback){
      callback(signOutResult);
      // yield put({ type: LOGOUT_SUCCESS, payload: null  });
   }
   yield put({ type: LOGOUT_SUCCESS, payload: null  });
  }


  function* asyncUpdatePassword(action) {
    const callback = action.payload.callback || (()=>({}));
    let result = yield call(  
      axiosUpdatePassword, {
        currentPassword: sha256(action.payload.currentPassword).toString(),
        newPassword: sha256(action.payload.newPassword).toString(),
        passwordHash: sha1(action.payload.newPassword).toString()
      }
    );
    

    if(callback){
      callback(result)
   }
  }
  
  function* mySaga() {
    yield takeLatest(ASYNC_SIGNIN, asyncSignIn);
    yield takeLatest(ASYNC_LOGOUT, asyncSignOut);
    yield takeLatest(ASYNC_UPDATE_PASSWORD, asyncUpdatePassword);
  }

  export default mySaga;